import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {FrontIDComponent} from './pages/front-id/front-id.component';
import {ScanRutComponent} from './pages/scan-rut/scan-rut.component';
import {FrontFaceComponent} from './pages/front-face/front-face.component';
import {SelfieComponent} from './pages/selfie/selfie.component';
import {FinalResultComponent} from './pages/final-result/final-result.component';
import {InputRutComponent} from './pages/input-rut/input-rut.component';
import {StepperComponent} from './pages/stepper/stepper.component';



const routes: Routes = [
  {
    path: '',
    redirectTo: 'selfie',
    pathMatch: 'full'
  },

  {
    path: 'inputRut',
    component: InputRutComponent,
    pathMatch: 'full'
  },
  {
    path: 'steps',
    component: StepperComponent,
    pathMatch: 'full'
  },
  {
    path: 'frontID',
    component: FrontIDComponent,
    pathMatch: 'full'
  },
  {
    path: 'scanRut',
    component: ScanRutComponent,
    pathMatch: 'full'
  },
  {
    path: 'frontFace',
    component: FrontFaceComponent,
    pathMatch: 'full'
  },
  {
    path: 'selfie',
    component: SelfieComponent,
    pathMatch: 'full'
  },
  {
    path: 'finalResult',
    component: FinalResultComponent,
    pathMatch: 'full'
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
